import { first, last, uniq } from "lodash";
import { dictionaryService } from "../../../dataFlow";
import { useCalendarDate, useDictionary, useDictionaryItem, useParameter } from "../../../shared";
import { SLIDE_NUMBER } from "../constants";

const YEAR_FREQUENCY = 1;

export function useSlideSubtitle() {
  const [startDateId] = useParameter<number>("@index_start");
  const [endDateId] = useParameter<number>("@index_end");

  const startDate = useCalendarDate(startDateId);
  const endDate = useCalendarDate(endDateId);

  const startIsYear = YEAR_FREQUENCY === +String(startDateId)[0];
  const endIsYear = YEAR_FREQUENCY === +String(endDateId)[0];

  const formatterFull = Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' });
  const formatterYear = Intl.DateTimeFormat('en-US', { year: 'numeric' });

  const datesLabels = uniq([
    [startDate, startIsYear ? formatterYear : formatterFull],
    [endDate, endIsYear ? formatterYear : formatterFull],
  ]
    .filter(([date]) => Boolean(date))
    .map(([date, formatter]) => (formatter as Intl.DateTimeFormat).format(date as Date)));

  const basedOn = datesLabels.join(' - ').toLowerCase();
  return `(Based on ${(basedOn ? `${basedOn}` : '')} average crop prices)`;
}